import React from 'react';
import { change as formChange, FormSection, getFormValues } from 'redux-form';

import { TextField, Section, SelectField, RadioField } from 'src/jbc-front/components/Form';
import { DeleteSquare } from 'jbc-front/components/icons';
import { isEnglish, isCorporateNumberForBranch, isEmpty, isPostalCode, isSocialSecurityNumber } from 'src/utils/CustomValidators';
import { CLIENT_FORM } from 'src/constants/FormNames';
import { TelFieldTh } from 'src/components';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getSelectOptions } from 'src/reducers/selectOptions';
import BranchImageSection from '../containers/BranchImageSection';
import styles from './BranchItemSection.scss';

class BranchItemSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      provinces: [],
      regionalTaxOffices: [],
      taxOffices: [],
      ssoOffices: [],
      subdistricts: [],
      regions: []
    };
    this._loadSelectOptions = this._loadSelectOptions.bind(this);
    this._handleProvinceChange = this._handleProvinceChange.bind(this);
    this._handleRegionalTaxOfficeChange = this._handleRegionalTaxOfficeChange.bind(this);
  }

  componentDidMount() {
    this._loadSelectOptions();
  }

  _getLocalizedLabel(element) {
    return this.props.i18n.language === 'vi' ? element.label : element.labelEn;
  }

  _loadSelectOptions() {
    const provincesArr = [];
    if (this.props.provinces && Array.isArray(this.props.provinces)) {
      this.props.provinces.forEach(element => {
        provincesArr.push({
          value: element.value,
          label: this._getLocalizedLabel(element)
        });
      });
    }
    const regionArr = [];
    this.props.regions.forEach(element => {
      regionArr.push({
        value: element.value,
        label: element.label
      });
    });

    this.setState(
      {
        provinces: provincesArr,
        regions: regionArr
      },
      () => {
        this._handleFilteredAddress(this.props.values?.clientBranch?.[this.props.index]?.provinceId);
      }
    );
  }

  _handleFilteredAddress(provinceId) {
    const filteredSubdistricts = this.props.subdistricts[provinceId] || [];
    const provincialRegionalTaxOffices = this.props.regionalTaxOffices[provinceId] || [];
    const specialTaxOffices = this.props.regionalTaxOffices[''] || [];
    const filteredSsoOffices = this.props.ssoOffices[provinceId] || [];

    const subdistrictArr = filteredSubdistricts.map(element => ({
      value: element.value,
      label: this._getLocalizedLabel(element)
    }));

    const allRegionalTaxOffices = [...provincialRegionalTaxOffices, ...specialTaxOffices];
    const regionalTaxOfficesArr = allRegionalTaxOffices.map(element => ({
      value: element.value,
      label: element.label,
      taxOfficeCode: element.taxOfficeCode
    }));

    const ssoOfficesArr = filteredSsoOffices.map(element => ({
      value: element.value,
      label: this._getLocalizedLabel(element)
    }));

    this.setState(
      {
        subdistricts: subdistrictArr,
        regionalTaxOffices: regionalTaxOfficesArr,
        ssoOffices: ssoOfficesArr
      },
      () => {
        const regionalTaxOfficeCode = this.props.values?.clientBranch?.[this.props.index]?.regionalTaxOfficeInformation?.taxOfficeCode;
        this._handleRegionalTaxOfficeChange(regionalTaxOfficeCode);
      }
    );
  }

  _handleRegionalTaxOfficeChange(regionalTaxOfficeCode) {
    if (this.state.currentRegionalTaxOfficeCode === regionalTaxOfficeCode) {
      return;
    }

    const allTaxOffices = Object.values(this.props.taxOffices).flat();
    const filteredTaxOffices = allTaxOffices.filter(
      element => element.parentTaxOfficeCode === regionalTaxOfficeCode || element.taxOfficeCode === regionalTaxOfficeCode
    );

    const taxOfficesArr = filteredTaxOffices.map(element => ({
      value: element.value,
      label: element.label
    }));

    this.setState({
      taxOffices: taxOfficesArr,
      currentRegionalTaxOfficeCode: regionalTaxOfficeCode
    });
  }

  _handleProvinceChange = provinceId => {
    if (!provinceId) {
      this.setState({ subdistricts: [], regionalTaxOffices: [], taxOffices: [], ssoOffices: [] });
      return;
    }

    const { dispatch, formKey } = this.props;

    dispatch(formChange(CLIENT_FORM, `${formKey}.subdistrictId`, null));
    dispatch(formChange(CLIENT_FORM, `${formKey}.regionalTaxOfficeId`, null));
    dispatch(formChange(CLIENT_FORM, `${formKey}.taxOfficeId`, null));
    dispatch(formChange(CLIENT_FORM, `${formKey}.ssoOfficeId`, null));

    this._handleFilteredAddress(provinceId);
  };
  render() {
    const { t } = this.props;
    const { formKey, index, remove, removable } = this.props;

    return (
      <div>
        <Section
          title={`${t('features.Clients.components.BranchItemSection.branch_information')} ${index + 1}`}
          icon={
            removable ? (
              <div className={styles.delete}>
                <DeleteSquare onClick={remove} />
              </div>
            ) : (
              <div className={styles.nodelete}>
                <DeleteSquare />
                <div className={styles.nodeleteText}>{this.props.t('features.Clients.components.BranchItemSection.cannot_delete')}</div>
              </div>
            )
          }
        >
          <FormSection name={formKey}>
            <TextField label={t('features.Clients.components.BranchItemSection.branch_name')} name="name" maxLength="255" required />
            <TextField label={t('features.Clients.components.BranchItemSection.branch_name_english')} name="nameEng" maxLength="255" validate={isEnglish} />
            <TextField
              label={t('features.Clients.components.BranchItemSection.tax_identification_number')}
              name="corporateNumber"
              maxLength="14"
              validate={isCorporateNumberForBranch}
              required
            />
            <TextField
              label={t('features.Clients.components.BranchItemSection.social_security_number')}
              name="employerNumber"
              maxLength="7"
              validate={isSocialSecurityNumber}
            />

            <RadioField
              label={t('features.Clients.components.BranchItemSection.branch_accounting_type')}
              name="isDependentBranch"
              options={this.props.branchAccountingTypes}
              note={t('features.Clients.components.BranchItemSection.branch_accounting_type_note')}
            />

            <TelFieldTh required label={t('features.Clients.components.BasicInfoSectionShow.phone_number')} />

            <div>
              <SelectField
                required
                label={t('features.Clients.components.BasicInfoSectionShow.province')}
                name="provinceId"
                options={this.state.provinces}
                placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select')}
                validate={isEmpty}
                onChange={this._handleProvinceChange}
              />
            </div>

            <div>
              <SelectField
                required
                label={t('features.Clients.components.BasicInfoSectionShow.subdistricts')}
                name="subdistrictId"
                options={this.state.subdistricts}
                placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select')}
                validate={isEmpty}
              />
            </div>

            <div>
              <TextField label={t('features.Clients.components.BasicInfoSectionShow.address')} type="text" name="address" />
            </div>

            <TextField label={t('features.Clients.components.BasicInfoSectionShow.postal_code')} maxLength="5" validate={isPostalCode} name="postalCode" />

            <SelectField
              required
              label={t('features.Clients.components.BasicInfoSectionShow.regional_tax_office')}
              name="regionalTaxOfficeId"
              options={this.state.regionalTaxOffices}
              placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select_regional_tax_office')}
              validate={isEmpty}
              onChange={regionalTaxOfficeId => {
                this.props.dispatch(formChange(CLIENT_FORM, `${formKey}.taxOfficeId`, null));
                const selectedOption = this.state.regionalTaxOffices.find(option => option.value === regionalTaxOfficeId);
                this._handleRegionalTaxOfficeChange(selectedOption?.taxOfficeCode);
              }}
            />

            <SelectField
              required
              label={t('features.Clients.components.BasicInfoSectionShow.management_tax_office')}
              name="taxOfficeId"
              options={this.state.taxOffices}
              placeholder={t('features.Clients.components.BasicInfoSectionShow.please_select_management_tax_office')}
              validate={isEmpty}
            />

            <SelectField
              required
              label={t('features.Clients.components.BasicInfoSectionShow.thai_sso_office')}
              name="ssoOfficeId"
              options={this.state.ssoOffices}
              placeholder="Please select sso office"
              validate={isEmpty}
            />

            <SelectField
              required
              label={t('features.Clients.components.BasicInfoSectionShow.region')}
              name="region"
              options={this.state.regions}
              placeholder="Please select region"
              note={t('features.Clients.components.BasicInfoSectionShow.region_tooltip')}
              validate={isEmpty}
            />

            <BranchImageSection label={t('features.Clients.components.BranchItemSection.branch_image')} name="branchImage" formKey={formKey} />
          </FormSection>
        </Section>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  provinces: getSelectOptions(state, 'provinces'),
  subdistricts: getSelectOptions(state, 'subdistricts'),
  ssoOffices: getSelectOptions(state, 'ssoOffices'),
  regionalTaxOffices: getSelectOptions(state, 'regionalTaxOffices'),
  taxOffices: getSelectOptions(state, 'taxOffices'),
  regions: getSelectOptions(state, 'regions'),
  branchAccountingTypes: getSelectOptions(state, 'branchAccountingTypes'),
  values: getFormValues(CLIENT_FORM)(state)
});

export default withTranslation()(connect(mapStateToProps)(BranchItemSection));
